module.exports = __webpack_public_path__ + "img/hr-V-R-6-unload-standup-shadow.5575046e.png";